import { useQuery } from '@tanstack/react-query';

import { getLanguages } from '../services/api/language';

export function useLanguage() {
  return useQuery({
    queryKey: ['languages'],
    queryFn: async () => {
      const data = await getLanguages();
      return data;
    },
  });
}
